import { render, staticRenderFns } from "./SuggestionsRow.vue?vue&type=template&id=538bc903&"
import script from "./SuggestionsRow.vue?vue&type=script&lang=js&"
export * from "./SuggestionsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports